import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useTelegram } from '../../context/TelegramContext';
import SettingsSection from './SettingsSection';

const SettingsItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
`;

const SwitchLabel = styled.span`
  flex: 1;
  font-size: 14px;
  color: #4a6fa1;
`;

const Switch = styled.label`
  position: relative;
  display: inline-block;
  width: 48px;
  height: 24px;
  
  input {
    opacity: 0;
    width: 0;
    height: 0;
    
    &:checked + .slider {
      background: linear-gradient(145deg, #6a11cb, #2575fc);
    }
    
    &:checked + .slider:before {
      transform: translateX(24px);
    }
  }
  
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #e0e5ec;
    box-shadow: inset 2px 2px 4px rgba(0, 0, 0, 0.05),
                inset -2px -2px 4px rgba(255, 255, 255, 0.5);
    border-radius: 24px;
    transition: all 0.3s ease;
    
    &:before {
      position: absolute;
      content: "";
      height: 18px;
      width: 18px;
      left: 3px;
      bottom: 3px;
      background: white;
      border-radius: 50%;
      transition: all 0.3s ease;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
    }
  }
`;

const DisplaySettingsSection = () => {
  const { t } = useTranslation();
  const { telegramUserId } = useTelegram();
  const [showComparison, setShowComparison] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchComparisonSetting();
  }, [telegramUserId]);

  const fetchComparisonSetting = async () => {
    try {
      setIsLoading(true);
      const response = await fetch(`https://fftg.farodinprojects.org:3000/get_comparison_setting?user_id=${telegramUserId}`);
      const data = await response.json();
      
      if (response.ok) {
        setShowComparison(data.show_comparison);
      }
    } catch (error) {
      console.error('Error fetching comparison setting:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleComparisonToggle = async () => {
    const newState = !showComparison;
    
    // Оптимистичное обновление UI
    setShowComparison(newState);
    
    try {
      await fetch('https://fftg.farodinprojects.org:3000/update_comparison_setting', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          user_id: telegramUserId,
          show_comparison: newState
        })
      });
    } catch (error) {
      console.error('Error updating comparison setting:', error);
      // Возвращаем предыдущее состояние в случае ошибки
      setShowComparison(!newState);
    }
  };

  return (
    <SettingsSection title={t('display_settings_title')}>
      {isLoading ? (
        <p>{t('loading')}</p>
      ) : (
        <SettingsItem>
          <SwitchLabel>
            {showComparison ? t('comparison_on') : t('comparison_off')}
          </SwitchLabel>
          <Switch>
            <input
              type="checkbox"
              checked={showComparison}
              onChange={handleComparisonToggle}
            />
            <span className="slider"></span>
          </Switch>
        </SettingsItem>
      )}
    </SettingsSection>
  );
};

export default DisplaySettingsSection;